import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";

function PalAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "40em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "15%"}}>
                                        1 mese
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        3 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        6 mesi
                                    </th>
                                    <th scope="col" style={{width: "15%"}}>
                                        11 mesi
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Orario pieno</th>
                                    <td className={"data-cell"}>109€</td>
                                    <td className={"data-cell"}>264€</td>
                                    <td className={"data-cell"}>468€</td>
                                    <td className={"data-cell"}>660€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Orario ridotto <br/> <span style={{fontSize: "12px"}}>(fino alle 18)</span></th>
                                    <td className={"data-cell"}>89€</td>
                                    <td className={"data-cell"}>240€</td>
                                    <td className={"data-cell"}>348€</td>
                                    <td className={"data-cell"}>480€</td>
                                </tr>
                                <tr>
                                    <th scope="row">Universitari <br/> <span style={{fontSize: "12px"}}>(orario pieno)</span></th>
                                    <td className={"data-cell"}>80€</td>
                                    <td className={"data-cell"}>198€</td>
                                    <td className={"data-cell"}>327€</td>
                                    <td className={"data-cell"}>462€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <br/>
                        </div>
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "20em"}}>
                                <thead >
                                <tr >
                                    <th scope="col" ></th>
                                    <th scope="col" style={{width: "30%"}}>
                                        Singolo
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="row">Ingressi</th>
                                    <td className={"data-cell"}>15€</td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <AllertIscrizione />
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PalAccordionPrezzi